import { useLanguage } from "@/context/LanguageContext";
import Marquee from "react-fast-marquee";
import { Zap, MessageCircle, Mail, Code2, Calculator, Radio, FileQuestion, Headphones, Eye, Users } from "lucide-react";

export function IntegrationsMarquee() {
  const { t } = useLanguage();

  const integrations = [
    { icon: Zap, label: t("integrations.urge"), color: "text-orange-600 bg-orange-50" },
    { icon: MessageCircle, label: t("integrations.whatsapp"), color: "text-green-600 bg-green-50" },
    { icon: Mail, label: t("integrations.smtp"), color: "text-blue-600 bg-blue-50" },
    { icon: Code2, label: t("integrations.api"), color: "text-violet-600 bg-violet-50" },
    { icon: Calculator, label: t("integrations.accounting"), color: "text-rose-600 bg-rose-50" },
    { icon: Radio, label: t("integrations.communication"), color: "text-cyan-600 bg-cyan-50" },
    { icon: FileQuestion, label: t("integrations.quoteRequest"), color: "text-amber-600 bg-amber-50" },
    { icon: Headphones, label: t("integrations.afterSales"), color: "text-sky-600 bg-sky-50" },
    { icon: Eye, label: t("integrations.brandless"), color: "text-slate-600 bg-slate-100" },
    { icon: Users, label: t("integrations.b2bCrm"), color: "text-indigo-600 bg-indigo-50" },
  ];

  return (
    <section data-testid="integrations-section" className="py-16 sm:py-20 bg-slate-50 border-y border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-10">
        <div className="text-center">
          <span className="text-sm uppercase tracking-[0.2em] font-bold text-[#22A7D1]">
            {t("integrations.overline")}
          </span>
          <h2 className="mt-3 text-3xl sm:text-4xl tracking-tight font-bold text-slate-900">
            {t("integrations.title")}
          </h2>
        </div>
      </div>

      <Marquee speed={35} gradient={true} gradientColor="rgb(248, 250, 252)" gradientWidth={80} pauseOnHover>
        {integrations.map((item, i) => {
          const Icon = item.icon;
          return (
            <div
              key={i}
              className="flex items-center gap-3 mx-4 px-5 py-3 rounded-xl border border-slate-200 bg-white hover:border-slate-300 transition-colors"
              data-testid={`integration-${i}`}
            >
              <div className={`w-9 h-9 rounded-lg flex items-center justify-center ${item.color}`}>
                <Icon className="w-4 h-4" />
              </div>
              <span className="text-sm font-medium text-slate-700 whitespace-nowrap">{item.label}</span>
            </div>
          );
        })}
      </Marquee>
    </section>
  );
}
